import { render } from 'solid-js/web';
import App from './App';
import { AdminContextProvider } from "./AdminContext";
import { UserContextProvider } from "./UserContext";
import { ConnectionManagerProvider } from './ConnectionManager';
import { OfflineDataManagerProvider } from './OfflineDataManager';
import { I18nProvider } from './i18n';
import '@fortawesome/fontawesome-free/css/all.css';

// Register service worker for offline capabilities
// Using URL constructor which works with Parcel
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Instead of using a string literal, use a URL object
    const swUrl = new URL('./service-worker.js', import.meta.url);
    navigator.serviceWorker.register(swUrl)
      .then(registration => {
        console.log('Service worker registered successfully with scope:', registration.scope);
      })
      .catch(error => {
        console.error('Service worker registration failed:', error);
      });
  });
}

const app = document.getElementById('app');
if (app) {
  render(() => <div>
    {/* ConnectionManagerProvider must be at the top level */}
    <ConnectionManagerProvider>
      {/* OfflineDataManagerProvider depends on ConnectionManager */}
      <OfflineDataManagerProvider>
        {/* User and Admin contexts can now consume connection and offline data */}
        <UserContextProvider>
          <AdminContextProvider>
            <I18nProvider>
              <App />
            </I18nProvider>
          </AdminContextProvider>
        </UserContextProvider>
      </OfflineDataManagerProvider>
    </ConnectionManagerProvider>
    
    <footer class="footer" style={{display:'none'}}>
      <div class="container">
        <span class="text-muted"><a href="http://bramas.fr">bramas.fr</a></span>{' | '}
        <span class="text-muted"><a href="#" onclick={() => {}}>Se déconnecter</a></span>
      </div>
    </footer>
  </div>, app);
}